function	LeadsAlert() {
	return (
		<p>Alert</p>
	);
}


export default LeadsAlert;
